import classNames from 'classnames/bind';
import styles from './TitleComp2.module.scss';
import { useRef } from 'react';
import useOnScreen from '~/hooks/useOnScreen';
import useOnScreen2 from '~/hooks/useOnScreen2';

const cx = classNames.bind(styles);

function TitleComp2({ children, className }) {
  const ref = useRef(null);
  const isOnScreen = useOnScreen(ref);
  const isOnScreen2 = useOnScreen2(ref);

  return (
    <div ref={ref} className={cx('title', className, { show: isOnScreen2 })}>
      <h2 className={cx({ show: isOnScreen })}>{children}</h2>
    </div>
  );
}

export default TitleComp2;
